// "Always allow" choices for chat tools, per clinician, in this browser - the
// way Claude remembers a tool you said yes to. Keyed by a tool's permissionKey
// (name@version), so a tool whose behavior changes gets a new key and asks
// again instead of inheriting an old yes. Remembering only skips the question:
// the tool still runs with the clinician's own session and checks.

const KEY_PREFIX = 'comprehendpt_chat_tool_permissions_';

function storageKey(email) {
  return KEY_PREFIX + String(email || 'anonymous').toLowerCase();
}

/** { [permissionKey]: { label, rememberedAt } } */
export function readRememberedTools(email) {
  try {
    const parsed = JSON.parse(localStorage.getItem(storageKey(email)));
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (err) {
    return {};
  }
}

function writeRememberedTools(email, remembered) {
  try {
    localStorage.setItem(storageKey(email), JSON.stringify(remembered));
  } catch (err) {
    // Storage unavailable: the choice lasts this page load only
  }
}

export function isToolRemembered(email, permissionKey) {
  return Boolean(readRememberedTools(email)[permissionKey]);
}

export function rememberTool(email, permissionKey, label) {
  const remembered = readRememberedTools(email);
  remembered[permissionKey] = { label: label || permissionKey, rememberedAt: new Date().toISOString() };
  writeRememberedTools(email, remembered);
}

export function forgetTool(email, permissionKey) {
  const remembered = readRememberedTools(email);
  delete remembered[permissionKey];
  writeRememberedTools(email, remembered);
}
